import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { pickPolicyView, pickQuoteView } from "../../store/selectors";

import HighlightableText from "./highlightable-text";

export const searchableTextCollection = new Set();

interface SearchableTextProps {
  fieldLabel?: string;
  fieldValue?: string;
  text?: string;
  className?: string;
  section?: string;
  searchText?: string;
  type: "quote" | "policy";
}

export const SearchableText = ({
  text = "",
  className,
  fieldLabel = "",
  fieldValue = "",
  section,
  type = "quote"
}: SearchableTextProps) => {
  const inputRef = useRef(null);
  const { searchText } =
    type === "quote" ? useSelector(pickQuoteView) : useSelector(pickPolicyView);

  useEffect(() => {
    const searchableTextObject = {
      props: {
        text,
        fieldLabel,
        fieldValue,
        section,
        searchText
      },
      ref: inputRef.current
    };
    searchableTextCollection.add(searchableTextObject);
    return () => {
      searchableTextCollection.delete(searchableTextObject);
    };
  });

  return (
    <span
      ref={inputRef}
      className={`SearchBar-searchableText ${className || ""}`}
    >
      <HighlightableText
        fullText={text}
        textToMatch={searchText.trim()}
        highlightClass="SearchBar-highlightedSearch"
      />
    </span>
  );
};

SearchableText.propTypes = {
  fieldLabel: PropTypes.string,
  fieldValue: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  section: PropTypes.string,
  searchText: PropTypes.string,
  type: PropTypes.string
};

SearchableText.defaultProps = {
  text: "",
  fieldLabel: "",
  fieldValue: "",
  searchText: "",
  type: "quote"
};
